import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {ItemCountView} from '../../ui_canvas_engine/ItemCountView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {TranslationObject} from '@colonist/i18n'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export abstract class UIGamePlayerInformationLongestRoadView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly isMyPlayer: boolean
    readonly playerState: PlayerValidator
    protected readonly playerInformation: UIGamePlayerInformationView

    protected longestRoadView: ItemCountView

    protected readonly longestRoadTexture: PIXI.Texture
    private readonly longestRoadHighlightTexture: PIXI.Texture

    constructor(uiGameManager: UIGameManager, playerState: PlayerValidator) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerState = playerState

        this.longestRoadTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_longest_road)
        this.longestRoadHighlightTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_longest_road_highlight)

        const playerInformation = this.uiGameManager.playersController?.getPlayerInformationViewWithColor(this.playerState.color)
        if(playerInformation == undefined) return
        this.playerInformation = playerInformation

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        this.isMyPlayer = this.playerInformation.player.color == bottomPlayerColor
        const isCityImprovementActive = this.playerInformation.cityImprovementPlayerState !== undefined
        isCityImprovementActive ? this.createCityImprovementLongestRoadView(this.isMyPlayer) : this.createDefaultLongestRoadView(this.isMyPlayer)
        this.createTooltip()
        this.updatePlayerLongestRoadCount()
    }

    private createTooltip() {
        if(UIUtilsEjsVariables.isUserOnMobileApp) return
        const title: TranslationObject = {
            key: 'strings:game.playerInformation.longestRoad.title',
            options: {context: this.uiGameManager.gameState.gameModeData.translationKeyContext},
        }
        const body: TranslationObject = {
            key: 'strings:game.playerInformation.longestRoad.body',
            options: {context: this.uiGameManager.gameState.gameModeData.translationKeyContext},
        }
        this.longestRoadView.view.setTip(title, [body])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updatePlayerLongestRoadCount(); break
            case UIGameEventEnums.HoveredOverPlayerInformationArrow: this.longestRoadView.hideView(); break
            case UIGameEventEnums.PointerOutPlayerInformationView: this.longestRoadView.showView(this.playerInformation); break
            default: break
        }
    }

    private createDefaultLongestRoadView(isMyColor: boolean) {
        isMyColor ? this.createMyDefaultLongestRoadView() : this.createOpponentDefaultLongestRoadView()
    }

    private createCityImprovementLongestRoadView(isMyColor: boolean) {
        isMyColor ? this.createMyCitiesAndKnightsLongestRoadView() : this.createOpponentCitiesAndKnightsLongestRoadView()
    }

    protected abstract createMyDefaultLongestRoadView(): void
    protected abstract createOpponentDefaultLongestRoadView(): void
    protected abstract createMyCitiesAndKnightsLongestRoadView(): void
    protected abstract createOpponentCitiesAndKnightsLongestRoadView(): void

    private updatePlayerLongestRoadCount() {
        if(this.longestRoadView == undefined) return

        const longestRoad = this.playerInformation.longestRoadPlayerState?.longestRoad ?? 0
        this.longestRoadView.updateText({key: 'strings:colonistCommon.utils.#buffer', options: {value: longestRoad}})

        const hasLongestRoad = this.playerInformation.longestRoadPlayerState?.hasLongestRoad ?? false
        hasLongestRoad ? this.longestRoadView.view.updateTexture(this.longestRoadHighlightTexture) : this.longestRoadView.view.updateTexture(this.longestRoadTexture)
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
